/**
 * Canonical feature permission names used with useFeaturePermission().
 * Centralised here so a typo becomes a compile error instead of a silent false.
 */
export const FeatureName = {
  PLANNING: 'planning',
  DISPATCHING: 'dispatching',
  DISPATCHING_RIDESHARE: 'dispatching-rideshare',
  USER_MANAGEMENT: 'user-management',
  DRIVER_MANAGEMENT: 'driver-management',
  INVOICES: 'invoices',
  APPRAISALS: 'appraisals',
  GUEST_RIDES: 'guestrides',
  MOBILE_SERVICE: 'mobile-service',
  PARTS_DELIVERY: 'parts-delivery',
} as const;

export type FeatureName = (typeof FeatureName)[keyof typeof FeatureName];
